import React, { useState, useEffect, useMemo, useRef } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import GroupsFunctionsGetter from '../../Controller/getSQLGroupsFunctions.js';
import { useTable } from "react-table";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
//import Gateway from './Gateway.js';
import DeleteObject from '../Common/DeleteObject.js';
import AddGroup from './AddGroup.js';
import EditGroup from './EditGroup.js';
import {FormattedMessage} from 'react-intl';
import { Icon } from 'semantic-ui-react';

const GroupList = (props) => {
  const [group_list, setGroupList] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [display_Add_Group_Popup, setAddGroupPopup] = useState(false);
  const [display_Edit_Group_Popup, setEditGroupPopup] = useState(false);
  const [display_Delete_Group_Popup, setDeleteGroupPopup] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState([]);

  const groupRef = useRef();
  groupRef.current = group_list;

  useEffect(() => {
    retrieveGroupList();
  },
  //eslint-disable-next-line 
  []);

  const onChangeSearchName = (e) => {
    const searchName = e.target.value;
    setSearchName(searchName);
  };

  const retrieveGroupList = async () => {
    let local_group_List = [];

    // get group list
    local_group_List = await GroupsFunctionsGetter.get_Structure_Groups();
    
    if((local_group_List !== "none")&&(local_group_List !== undefined)&&(local_group_List.length >= 0)){ 
      setGroupList(local_group_List);      
    }
    else{
      setGroupList([]);
    }
  };

  const editOrDeleteGroup = (rowIndex, action) => {
  //  console.log("Edit Or Delete Group");
    setSelectedGroup(groupRef.current[rowIndex]);   

    if(action === "delete"){   
      manageDeleteGroupDisplay()
    }
    else{
      manageEditGroupDisplay();
    }
  };

  const findGroupByName = async () => {
    if(searchName.length !== 0){
      let group = await GroupsFunctionsGetter.get_Structure_Groups_by_name(searchName)
      .then((response) => {
        setGroupList(response);
      })
      .catch((e) => {
        console.log(e);
      });
    }
    else{
      retrieveGroupList();
    }
  };

  // turn on-off popup
  const manageAddGroupDisplay = () => {
    setAddGroupPopup(!display_Add_Group_Popup);
  };

  // turn on-off popup
  const manageEditGroupDisplay = () => {
    setEditGroupPopup(!display_Edit_Group_Popup);
  };

  // turn on-off popup
  const manageDeleteGroupDisplay = () => {
    setDeleteGroupPopup(!display_Delete_Group_Popup);
  };

  const closeAfterAdding = () => {
    retrieveGroupList();
    manageAddGroupDisplay();
  };

  const closeAfterEdition = () => {
    retrieveGroupList();
    manageEditGroupDisplay();
  };

  const closeAfterDeletion = () => {
    retrieveGroupList();
    manageDeleteGroupDisplay();
  };

  let headersList = [
      {
        Header: <FormattedMessage id="group.name" defaultMessage="Name" /> ,
        accessor: "group_name",
      },  

      {
        Header: <FormattedMessage id="group.description" defaultMessage="Description" /> ,
        accessor: "description",
      }, 
  ]
  if (props.accountInformation.readOnly !== true) {
    headersList.push({
        Header: <FormattedMessage id="button.action" defaultMessage="Action" /> ,
        accessor: "actions",
        Cell: (props) => {
          const rowIdx = props.row.id;
          return (
            <div>
              <span onClick={() => editOrDeleteGroup(rowIdx, "edit")}
                  data-tooltip="Modifier">
                <i className="fas fa-edit action"></i>
              </span>
              <b>&emsp;</b>
              <span onClick={() => editOrDeleteGroup(rowIdx, "delete")}
                  data-tooltip="Supprimer">
                <i className="fas fa-trash action"></i>
              </span>
            </div>
          );
        },
    })
      }

  const columns = useMemo(
    () => headersList,
    //eslint-disable-next-line
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data: group_list,
  });

  return (
    <div>
      <Row>
        <Col sm={8} style = {{width:"50%"}}>
          <Row>
            <input
              type="text"
              className="form-control"
              placeholder="Recherche par nom"
              value={searchName}
              onChange={onChangeSearchName}
              style = {{width:"40%"}}
            />
            <button className="btn btn-outline-secondary" onClick={findGroupByName} style={{width:"auto", maxWidth:"30%"}}>
              <Icon name='search' size='large' inverted color='black'/>
            </button>
          </Row>
        </Col>
        <Col sm={4} style={{ width: "50%", display: "flex", flexDirection: "row", justifyContent: "right"}}>
          {props.accountInformation.readOnly === true ?
            null
            :
          <button className="btn btn-sm btn-success" onClick={manageAddGroupDisplay} style={{ width: "100px", fontSize: "0.9em"}}>
            <FormattedMessage id="button.add" defaultMessage="Add" />
          </button>
          }
        </Col>
      </Row>
      <br/>
      <Row style={{ maxHeight:"65vh", overflowY: 'auto'}}>
        <table
          className="table table-striped table-bordered"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </Row>     
      {display_Add_Group_Popup ? <AddGroup structure_Id={props.structure_Id} closeAfterAdd={closeAfterAdding} cancelPopup={manageAddGroupDisplay} reloadGroups={props.reloadGroups}/> : null}
      {display_Edit_Group_Popup ? <EditGroup group={selectedGroup} structure_Id={props.structure_Id} closeAfterEdition={closeAfterEdition} reloadGroups={props.reloadGroups} cancelPopup={manageEditGroupDisplay}/> : null}
      {display_Delete_Group_Popup ? <DeleteObject structure_Id={props.structure_Id} closeAfterDelete={closeAfterDeletion} reloadGroups={props.reloadGroups} cancelPopup={manageDeleteGroupDisplay} id={selectedGroup.id_group} object_type={"group"} object_name={selectedGroup.group_name}/> : null}
    </div>
  );
};

export default withStyles(Constants.styles)(GroupList);
